import useLoginController from '@auth/api/useLoginController'
import context from '@helpers/context'
import React from 'react'

const [
    AuthContext, 
    useAuthContext
] = context<Contexts.Auth>()

export { useAuthContext }
export default function AuthProvider({ children }: React.PropsWithChildren<{}>) {
    const controller = useLoginController()
    const user = controller.user.use()
    return <AuthContext.Provider value={user}>{children}</AuthContext.Provider>
}